import { Scope } from "./scope.enum";

export interface User {
  id_token?: string,
  entityid?: string,
  email?: string,
  prefix?: string,
  firstname?: string,
  lastname?: string,
  password?: string,
  phone?: string,
  scope?: Scope,  
  firebasetoken?: string;
}

export interface UserOrg {
  id_token?: string,
  refid?: string,
  refemail?: string,
  refprefix?: string,
  reffirstname?: string,
  reflastname?: string,
  refcompany?: string,
  refpassword?: string,
  refphone?: string,
  scope?: Scope,  
  firebasetoken?: string;
}

export interface UserAdm {
  id_token?: string,
  adminid?: string,
  adminemail?: string,
  adminfirstname?: string,
  adminlastname?: string,
  admincompany?: string,
  adminpassword?: string,
  scope?: Scope,  
}
